import { render, staticRenderFns } from "./ConfigStatusList.vue?vue&type=template&id=c5e4df80&scoped=true"
import script from "./ConfigStatusList.vue?vue&type=script&lang=js"
export * from "./ConfigStatusList.vue?vue&type=script&lang=js"
import style0 from "./ConfigStatusList.vue?vue&type=style&index=0&id=c5e4df80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5e4df80",
  null
  
)

export default component.exports